export {default} from './MainContainer';



// WEBPACK FOOTER //
// ./src/components/AuthLayout/MainContainer/index.ts